import React, {Component} from 'react';
import Vas from './Vas';

class HomeOffline extends Component{

    componentDidMount(){
        Vas.GetView("Tariffing");
    }
    render()
    {
        return(<div className={"Start"}>
            
            <center>
                
            </center>
        </div>);
    }
}
export default HomeOffline;